<template>
    <div ref="box" style="display:none;">
        <!-- 头部 -->
        <div class="bar-manager-header">
            <header-top @refresh="refresh"></header-top>
        </div>
        <!-- 表格部分 -->
        <div class="table-content">
            <server-table-list :table-list="tableData.list"></server-table-list>
        </div>
        <!-- 分页功能 -->
        <!-- <div class="table-pagination">
            <page-component :total="total"
                :current-page='page'
                :loading="tableLoading"
                @pagechange="getBarList"></page-component>
        </div> -->
    </div>
</template>

<script>
// 头部tag内容
import HeaderTop from "./header";
// 网吧列表
import ServerTableList from "./serverTableList";

import { getServerList } from "@/requests/bar";

export default {
    name: "recentRemote",
    components: {
        HeaderTop,
        ServerTableList
    },
    data() {
        return {
            total: 0,
            page: 1,
            tableData: {
                list: []
            },
            tableLoading: false
        };
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                // this.$domFn.addAnimateClass(this.$refs.box, 'animated fadeInRight')
                this.$refs.box.style.display = "block";
            });
        });
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.getBarList(1);
        });
    },
    methods: {
        // 获取所有网吧列表
        /* eslint-disable */
        async getBarList(page) {
            this.tableData.list = [];
            this.tableLoading = true;
            let res = await getServerList({
                type: 1,
                page: 1,
                pageSize: 30
            });
            this.tableData.list = res.records;
            this.total = parseInt(res.total);
            this.page = parseInt(res.current);
            this.tableLoading = false;
        },
        refresh() {
            this.getBarList(this.page);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";

.bar-manager-header {
    height: 70px;
    line-height: 70px;
    border-bottom: 1px solid #d9dee4;
}
.table-content {
    padding-top: 10px;
    padding-left: 30px;
    padding-right: 30px;
}
.table-pagination {
    text-align: right;
    padding-right: 80px;
    padding-top: 20px;
    > div {
        display: inline-block;
    }
}
</style>
